import { renderToStaticMarkup } from "react-dom/server";
import { getCitationFilePath } from "../../api";

type HtmlParsedAnswer = {
    answerHtml: string;
    citations: string[];
};

/*** removes urls and strings with specified url patterns are kept
 * other regex can be specified to remove strings, e.g. const private_regex = /\[.*?private_.*?\]/gi; to remove sources containing private_
 */
function removeUrlsExceptSpecific(text: string, keepUrl: string[], extraRegex?: RegExp): string {
    const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]|\bwww\.[a-z0-9\-\.]+[a-z]{2,})/gi;

    const regexList = [urlRegex];

    if (extraRegex) {
        regexList.push(extraRegex);
    }
    console.log(extraRegex);
    const words = text.split(" ");

    const processedWords = words.map(word => {
        let keepWord = false;
        for (const url of keepUrl) {
            if (word.includes(url)) {
                keepWord = true;
                break; // Break the loop as soon as a match is found
            }
        }

        if (keepWord) {
            return word; // Return the word unchanged if a keepUrl is found within it
        } else {
            regexList.forEach(regex => {
                word = word.replace(regex, "");
            });
            return word;
        }
    });

    return processedWords.join(" ").trim();
}

export function parseAnswerToHtml(
    answer: string,
    isStreaming: boolean,
    isAdmin: boolean,
    onCitationClicked: (citationFilePath: string) => void
): HtmlParsedAnswer {
    /** we define the pattern to remove private sources */
    let private_source_regex: RegExp | undefined = /\[.*?private_.*?\]/gi;
    //if we have the url parameter admin=true we remove the source pattern to show all sources

    if (isAdmin) {
        private_source_regex = undefined;
    }

    const citations: string[] = [];

    // trim any whitespace from the end of the answer after removing follow-up questions
    let parsedAnswer = answer.trim();

    // Omit a citation that is still being typed during streaming
    if (isStreaming) {
        let lastIndex = parsedAnswer.length;
        for (let i = parsedAnswer.length - 1; i >= 0; i--) {
            if (parsedAnswer[i] === "]") {
                break;
            } else if (parsedAnswer[i] === "[") {
                lastIndex = i;
                break;
            }
        }
        const truncatedAnswer = parsedAnswer.substring(0, lastIndex);
        parsedAnswer = truncatedAnswer;
    }

    //remove urls but keep idrott online
    let cleanedanswer = removeUrlsExceptSpecific(parsedAnswer, ["idrottonline.se", "rf.se"], private_source_regex);

    const parts = cleanedanswer.split(/\[([^\]]+)\]/g);

    const fragments: string[] = parts.map((part, index) => {
        if (index % 2 === 0) {
            return part;
        } else {
            let citationIndex: number;
            if (citations.indexOf(part) !== -1) {
                citationIndex = citations.indexOf(part) + 1;
            } else {
                citations.push(part);
                citationIndex = citations.length;
            }

            const path = getCitationFilePath(part);

            return renderToStaticMarkup(
                <a className="supContainer" title={part} onClick={() => onCitationClicked(path)}>
                    <sup>{citationIndex}</sup>
                </a>
            );
        }
    });

    return {
        answerHtml: fragments.join(""),
        citations
    };
}
